var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, Circle, createIcon, Icon, Stack, useId, useRadio, useRadioGroup, useStyleConfig, } from '@chakra-ui/react';
import React, { Children, cloneElement, isValidElement, useMemo } from 'react';
export const RadioCardGroup = (props) => {
    const { children, name, defaultValue, value, onChange } = props, rest = __rest(props, ["children", "name", "defaultValue", "value", "onChange"]);
    const { getRootProps, getRadioProps } = useRadioGroup({
        name,
        defaultValue,
        value,
        onChange,
    });
    const cards = useMemo(() => Children.toArray(children)
        .filter(isValidElement)
        .map((card) => {
        return cloneElement(card, {
            radioProps: getRadioProps({
                value: card.props.value,
            }),
        });
    }), [children, getRadioProps]);
    return React.createElement(Stack, Object.assign({}, getRootProps(rest)), cards);
};
export const RadioCard = (props) => {
    const { radioProps, children } = props, rest = __rest(props, ["radioProps", "children"]);
    const { getInputProps, getCheckboxProps, getLabelProps, state } = useRadio(radioProps);
    const id = useId(undefined, 'radio-button');
    const styles = useStyleConfig('RadioCard', props);
    const inputProps = getInputProps();
    const checkboxProps = getCheckboxProps();
    const labelProps = getLabelProps();
    return (React.createElement(Box, Object.assign({ as: "label", cursor: "pointer" }, labelProps, { sx: {
            '.focus-visible + [data-focus]': {
                boxShadow: 'outline',
                zIndex: 1,
            },
        } }),
        React.createElement("input", Object.assign({}, inputProps, { "aria-labelledby": id })),
        React.createElement(Box, Object.assign({ sx: styles }, checkboxProps, rest),
            React.createElement(Stack, { direction: "row" },
                React.createElement(Box, { flex: "1" }, children),
                state.isChecked ? (React.createElement(Circle, { bg: "reaBlue.500", size: "4" },
                    React.createElement(Icon, { as: CheckIcon, boxSize: "2.5", color: "white" }))) : (React.createElement(Circle, { borderWidth: "2px", size: "4" }))))));
};
export const CheckIcon = createIcon({
    displayName: 'CheckIcon',
    viewBox: '0 0 12 10',
    path: (React.createElement("polyline", { fill: "none", strokeWidth: "2px", stroke: "currentColor", strokeDasharray: "16px", points: "1.5 6 4.5 9 10.5 1" })),
});
